import { forwardRef } from 'react';

import { ButtonBase } from './Defaults';

import type { ButtonBaseProps } from './Defaults';

type PrimaryActionButtonProps = Exclude<ButtonBaseProps, 'color'> & {
    readonly isSubmit?: boolean;
    readonly label: string;
};

export const PrimaryActionButton = forwardRef<HTMLButtonElement, PrimaryActionButtonProps>((props, ref) => {
    const { isDisabled = false, isSubmit, label, variant, ...rest } = props;

    return (
        <ButtonBase
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            ref={ref}
            color="primary"
            isDisabled={isDisabled}
            type={isSubmit === true ? 'submit' : undefined}
            variant={variant ?? 'text'}
        >
            {label}
        </ButtonBase>
    );
});
